import { MatIconModule } from "@angular/material/icon";
import { Component, EventEmitter, Input, Output, OnInit } from "@angular/core";
@Component({
  selector: "app-image-lightbox",
  standalone: true,
  templateUrl: "./image-lightbox.component.html",
  imports: [MatIconModule],
})
export class ImageLightboxComponent implements OnInit {
  @Input() images: string[] = [];
  @Input() startIndex = 0;
  @Output() close = new EventEmitter<void>();

  currentIndex = 0;

  scale = 1;
  zoomPercent = 100;

  posX = 0;
  posY = 0;

  private dragging = false;
  private startX = 0;
  private startY = 0;

  ngOnInit(): void {
    this.currentIndex = this.startIndex || 0;
    this.updateZoomPercent();
  }

  get currentImage(): string {
    return this.images[this.currentIndex];
  }

  next(): void {
    if (this.currentIndex < this.images.length - 1) {
      this.currentIndex++;
      this.resetTransform();
    }
  }

  prev(): void {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.resetTransform();
    }
  }

  selectImage(index: number): void {
    this.currentIndex = index;
    this.resetTransform();
  }

  zoomIn(): void {
    if (this.scale < 4) {
      this.scale += 0.25;
      this.updateZoomPercent();
    }
  }

  zoomOut(): void {
    if (this.scale > 1) {
      this.scale -= 0.25;
      if (this.scale <= 1) {
        this.resetTransform();
      }
      this.updateZoomPercent();
    }
  }

  onWheel(event: WheelEvent): void {
    event.preventDefault();
    event.deltaY < 0 ? this.zoomIn() : this.zoomOut();
  }

  startDrag(event: MouseEvent | TouchEvent): void {
    if (this.scale === 1) return;

    this.dragging = true;
    const p = this.getPoint(event);
    this.startX = p.x - this.posX;
    this.startY = p.y - this.posY;
  }

  onDrag(event: MouseEvent | TouchEvent): void {
    if (!this.dragging) return;

    const p = this.getPoint(event);
    this.posX = p.x - this.startX;
    this.posY = p.y - this.startY;
  }

  endDrag(): void {
    this.dragging = false;
  }

  closeViewer(): void {
    this.close.emit();
  }

  private resetTransform(): void {
    this.scale = 1;
    this.posX = 0;
    this.posY = 0;
    this.updateZoomPercent();
  }

  private updateZoomPercent(): void {
    this.zoomPercent = Math.round(this.scale * 100);
  }

  private getPoint(event: MouseEvent | TouchEvent) {
    if (event instanceof TouchEvent) {
      return {
        x: event.touches[0].clientX,
        y: event.touches[0].clientY,
      };
    }
    return {
      x: event.clientX,
      y: event.clientY,
    };
  }
}
